import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getAttendeeRegistrations,
    getAttendanceList
} from "../../../../../../app/store/slices/event/registration/registration";

export default function useRegistration() {
    const dispatch = useDispatch();
    const { eventData } = useSelector((state) => state.event);

    const [activeTab, setActiveTab] = useState('attendees');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchData() {
            if (!eventData || !eventData.eventId) return;

            setLoading(true);

            try {
                await dispatch(getAttendeeRegistrations(eventData?.eventId)).unwrap();
                await dispatch(getAttendanceList(eventData?.eventId)).unwrap();
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [eventData?.eventId]);

    return {
        activeTab,
        setActiveTab,
        loading,
        error
    }
}